package com.example.histoire.web

import kotlin.js.Date
import kotlinx.datetime.Clock
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.todayIn

data class AgeDisplay(val value: String, val unit: String)

private fun localDateFromJsToday(): LocalDate {
    val d = Date()
    return LocalDate(
        year = d.getFullYear().toInt(),
        monthNumber = d.getMonth().toInt() + 1,
        dayOfMonth = d.getDate().toInt(),
    )
}

fun ageDisplayForBirthDate(birthDateIso: String): AgeDisplay {
    val birth = LocalDate.parse(birthDateIso.trim())
    val today = try {
        Clock.System.todayIn(TimeZone.currentSystemDefault())
    } catch (_: Throwable) {
        localDateFromJsToday()
    }
    return ageDisplayForBirthDate(birth, today)
}

fun ageDisplayForBirthDate(birth: LocalDate, today: LocalDate): AgeDisplay {
    if (birth > today) return AgeDisplay("0", "mois")
    var months = (today.year - birth.year) * 12 + (today.monthNumber - birth.monthNumber)
    if (today.dayOfMonth < birth.dayOfMonth) {
        months -= 1
    }
    months = months.coerceAtLeast(0)
    val years = months / 12
    return if (years >= 1) {
        AgeDisplay(value = years.toString(), unit = "ans")
    } else {
        AgeDisplay(value = months.toString(), unit = "mois")
    }
}
